import BoatPage from "./BoatPage";
import { IMG } from "../../i18n/marketingImages";

export default function Greenline33() {
  return <BoatPage boatKey="gl33" image={IMG.gl33} testidBase="boat-33" />;
}
